/**
 * The home feed (CLAUDE.md 14.3).
 *
 * Kept in its own module rather than folded into `hooks.ts` because it belongs to a
 * page, not to a resource: one request answers "what is waiting for me", and nothing
 * else reads it.
 *
 * The key is workspace-scoped like every other workspace resource, so switching
 * workspaces cannot show the previous one's review queue under the new one's name --
 * which on this page would be worse than merely wrong, since the queue is a list of
 * work a person believes is theirs to sign off.
 */
import { useQuery } from '@tanstack/react-query'

import { api } from '@/api/client'
import type { HomeFeed } from '@/api/types'

export const homeKeys = {
  feed: (workspaceId: number | null) => ['home', workspaceId] as const,
}

export function useHomeFeed(workspaceId: number | null) {
  return useQuery({
    queryKey: homeKeys.feed(workspaceId),
    queryFn: () => api.get<HomeFeed>('/me/home'),
    enabled: workspaceId !== null,
  })
}
